/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MainWrapper from '../MainWrapper';
import ReactGA from 'react-ga';

// Auth imports
import SignIn from '../../Account/SignIn';
import SignUp from '../../Account/SignUp';
import Register from '../../Account/Register/index';
import ResetPassword from '../../Account/ResetPassword/index';
import GetOTP from '../../../shared/components/account/login_register/OtpGet';
import LayoutNew from '../../LayoutNew';

// Route protection
import ProtectedRoute from '../ProtectedRoute';
import ProtectedRouteNew from '../ProtectedRouteNew';
import PublicRoute from '../PublicRoute';
import NotFoundPage from './WrappedRoutes/NotFoundPage';
import HomeProducts from '../../../store/Layout/home/HomeProducts';
import Home from '../../../store/Layout/home/Home';

// Chat imports
import Chat from '../../Dashboards/Chat';
import RoomChat from '../../Dashboards/RoomChat';

// Ticket/Support imports
import Support from '../../Dashboards/Support';

// Profile imports
import Profile from '../../Account/Profile/index';

// Marketplace imports
// import CreateProduct from '../../../store/Layout/product/CreateProduct';
import CreateCheckoutView from '../../../store/Layout/product/checkoutView';
import Products from '../../../store/Layout/product/Products';
import ProductDetails from '../../../store/Layout/product/ProductDetails';
import ProductCart from '../../../store/Layout/product/ProductCart';
import MarketDashboard from '../../../store/Layout/dashboard/MarketDashboard';
import Dashboard from '../../../store/Layout/dashboard/Dashboard';
import CreateStoreWallet from '../../../store/Layout/createstore/index';
import StoreDetail from '../../../store/Layout/storedetail/StoreDetail';
import StoreCard from '../../../store/Layout/storedetail/StoreCard';
import EditStore from '../../../store/Layout/editstore/EditStore';
import StoreDetailUser from '../../../store/Layout/storedetail/StoreDetailUser';
import StoreGallery from '../../../store/Layout/store/StoreGallery';
import CreateStoreFlow from '../../../store/Layout/store/CreateStoreFlow';
import StoreDetailView from '../../../store/Layout/store/components/StoreDetailView';
import PharmaLotForm from '../../../store/Layout/store/components/PharmaLotForm';
import PharmaLotView from '../../../store/Layout/store/components/PharmaLotView';
import GroupPurchase from '../../../store/Layout/store/components/GroupPurchase';
import GroupPurchaseRoute from '../../../store/Layout/store/components/GroupPurchaseRoute';
import AuctionDetailView from '../../../store/Layout/store/components/AuctionDetailView';
import AuctionList from '../../../store/Layout/auction/AuctionList';
import CreateAuction from '../../../store/Layout/auction/CreateAuction';
import GetMyOrders from '../../../store/Layout/orders/GetMyOrders';
import GetMarketplaceContracts from '../../../store/Layout/orders/GetMarketplaceContracts';
import GetMyApproval from '../../../store/Layout/orders/GetMyApproval';
import GetMyOrderAsBuyer from '../../../store/Layout/orders/GetMyOrderAsBuyer';
import CustomOffer from '../../../store/Layout/custom-offer/CustomOffer';
import NewHomePage from '../../../store/Layout/home/NewHomePage';
import CustodiyActivityCalendar from '../../default_pages/Calendar';
import CreateContract from '../../default_pages/CreateContract';
import ContractList from '../../default_pages/ContractList';
import Subscription from '../../default_pages/Subscription';
import MyGroupsList from '../../../store/Layout/groups/MyGroupsList';

const Router = () => {
  const { isLoggedIn } = useSelector(state => state.user);
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location?.pathname + location.search);
  }, [location]);

  return (
    <MainWrapper>
      <main>
        <Switch>
          {/* Root route */}
          <Route exact path="/">
            {isLoggedIn ? (
              <Redirect to="/dashboard" />
            ) : (
              <div style={{ paddingTop: 0 }}>
                <NewHomePage />
              </div>
            )}
          </Route>

          {/* Auth Routes - Sign-in & Signup Flow */}
          <PublicRoute path="/sign-in" isAuthenticated={isLoggedIn}>
            <SignIn />
          </PublicRoute>
          <PublicRoute path="/sign-up" isAuthenticated={isLoggedIn}>
            <SignUp />
          </PublicRoute>
          <PublicRoute path="/register" isAuthenticated={isLoggedIn}>
            <Register />
          </PublicRoute>
          <PublicRoute path="/reset_password" isAuthenticated={isLoggedIn}>
            <ResetPassword />
          </PublicRoute>
          <PublicRoute path="/Webapistore" isAuthenticated={isLoggedIn}>
            <GetOTP />
          </PublicRoute>
          <ProtectedRouteNew path="/homeproducts">
            <HomeProducts />
          </ProtectedRouteNew>
          {/* Chat Routes */}
          <ProtectedRouteNew path="/chat" isAuthenticated={isLoggedIn}>
            <Chat />
          </ProtectedRouteNew>
          <ProtectedRoute path="/livechat" isAuthenticated={isLoggedIn}>
            <RoomChat />
          </ProtectedRoute>

          {/* Ticket/Support Routes */}
          <ProtectedRouteNew path="/support" isAuthenticated={isLoggedIn}>
            <Support />
          </ProtectedRouteNew>

          {/* Profile Routes */}
          <ProtectedRoute path="/profile" isAuthenticated={isLoggedIn}>
            <Profile />
          </ProtectedRoute>

          {/* Dashboard Route */}
          <ProtectedRoute path="/dashboard" isAuthenticated={isLoggedIn}>
            <Dashboard />
          </ProtectedRoute>
          <ProtectedRouteNew path="/store" >
            <StoreGallery />
          </ProtectedRouteNew>
          

          {/* Groups Routes */}
          <ProtectedRouteNew path="/groups/:groupId" isAuthenticated={isLoggedIn}>
            <GroupPurchaseRoute />
          </ProtectedRouteNew>
          <ProtectedRouteNew path="/my-groups" isAuthenticated={isLoggedIn}>
            <MyGroupsList />
          </ProtectedRouteNew>

          {/* Marketplace Routes */}
          <ProtectedRoute path="/marketdashboard" isAuthenticated={isLoggedIn}>
            <MarketDashboard />
          </ProtectedRoute>
          <ProtectedRoute path="/products" isAuthenticated={isLoggedIn}>
            <Products />
          </ProtectedRoute>
          <ProtectedRouteNew path="/productdetails">
            <ProductDetails />
          </ProtectedRouteNew>
          <ProtectedRouteNew path="/showcart">
            <ProductCart />
          </ProtectedRouteNew>
          <ProtectedRoute path="/checkout" isAuthenticated={isLoggedIn}>
            <CreateCheckoutView />
          </ProtectedRoute>
          {/* <ProtectedRoute path="/createproduct" isAuthenticated={isLoggedIn}>
            <CreateProduct />
          </ProtectedRoute> */}
          <ProtectedRoute path="/createstore" isAuthenticated={isLoggedIn}>
            <CreateStoreWallet />
          </ProtectedRoute>
          <ProtectedRoute path="/storecard" isAuthenticated={isLoggedIn}>
            <StoreCard />
          </ProtectedRoute>
          <ProtectedRoute path="/auction/create" isAuthenticated={isLoggedIn}>
            <CreateAuction />
          </ProtectedRoute>
          <ProtectedRoute path="/auction" exact isAuthenticated={isLoggedIn}>
            <AuctionList />
          </ProtectedRoute>
          <ProtectedRoute path="/auction/:auctionId" isAuthenticated={isLoggedIn}>
            <AuctionDetailView />
          </ProtectedRoute>
          <ProtectedRoute path="/storedetail/:storeId/auction/:auctionId" isAuthenticated={isLoggedIn}>
            <AuctionDetailView />
          </ProtectedRoute>
          <ProtectedRouteNew path="/storedetail/:storeId/add-lot" isAuthenticated={isLoggedIn}>
            <PharmaLotForm />
          </ProtectedRouteNew>
          <ProtectedRouteNew path="/storedetail/:storeId/lot/:lotId" isAuthenticated={isLoggedIn}>
            <PharmaLotView />
          </ProtectedRouteNew>
          <ProtectedRoute path="/storedetail/:storeId/group-purchase" isAuthenticated={isLoggedIn}>
            <GroupPurchase />
          </ProtectedRoute>
          <ProtectedRoute path="/storedetail/:storeId" isAuthenticated={isLoggedIn}>
            <StoreDetailView />
          </ProtectedRoute>
          <ProtectedRoute path="/storedetail" exact isAuthenticated={isLoggedIn}>
            <CreateStoreFlow />
          </ProtectedRoute>
          <ProtectedRoute path="/editstore" isAuthenticated={isLoggedIn}>
            <EditStore />
          </ProtectedRoute>
          <ProtectedRoute path="/storedetailuser/:storeId" isAuthenticated={isLoggedIn}>
            <StoreDetailUser />
          </ProtectedRoute>
          <ProtectedRoute path="/getmyorders" isAuthenticated={isLoggedIn}>
            <GetMyOrders />
          </ProtectedRoute>
          <ProtectedRoute path="/contractsLists" isAuthenticated={isLoggedIn}>
            <ContractList />
          </ProtectedRoute>
          <ProtectedRoute path="/getmyapproval" isAuthenticated={isLoggedIn}>
            <GetMyApproval />
          </ProtectedRoute>
          <ProtectedRoute path="/getmyorderasbuyer" isAuthenticated={isLoggedIn}>
            <GetMyOrderAsBuyer />
          </ProtectedRoute>
          <ProtectedRoute path="/customoffers" isAuthenticated={isLoggedIn}>
            <CustomOffer />
          </ProtectedRoute>

          {/* Default pages - Calendar */}
          <ProtectedRouteNew path="/default_pages/calendar">
            <CustodiyActivityCalendar />
          </ProtectedRouteNew>

          {/* Subscription */}
          <ProtectedRouteNew path="/subscription">
            <Subscription />
          </ProtectedRouteNew>

          {/* Create Safebox */}
          <ProtectedRouteNew path="/new-safebox">
            <CreateContract />
          </ProtectedRouteNew>

          {/* Safebox List */}
          <ProtectedRouteNew path="/safeboxes">
            <ContractList />
          </ProtectedRouteNew>

          {/* 404 Route */}
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </main>
    </MainWrapper>
  );
};
export default Router;
